import { useTranslation } from 'react-i18next';
import { Heart } from 'lucide-react';
import Countdown from '../ui/Countdown';

export default function CountdownStory() {
  const { t } = useTranslation();
  return (
    <section
      className="bg-brand-paper-warm/70"
      aria-label="Countdown and story"
    >
      <div className="mx-auto max-w-6xl px-6 py-12 sm:py-14 grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6 items-center">
        <blockquote className="text-center md:text-left md:pr-8">
          <p className="font-serif italic text-brand-ink/80 text-sm sm:text-base leading-relaxed">
            “{t('countdownStory.quote')}”
          </p>
          <footer className="mt-2 font-sans text-[0.65rem] tracking-widest uppercase text-brand-gold">
            {t('countdownStory.quoteAuthor')}
          </footer>
        </blockquote>

        <div className="text-center">
          <p className="font-sans text-[0.65rem] sm:text-[0.7rem] tracking-widest uppercase text-brand-ink/70 mb-4">
            {t('countdownStory.countdownLabel')}
          </p>
          <Countdown />
        </div>

        <p className="text-center md:text-right md:pl-8 font-serif italic text-brand-ink/80 text-sm sm:text-base leading-relaxed inline-flex items-center justify-center md:justify-end gap-2">
          <span>{t('countdownStory.thanks')}</span>
          <Heart size={14} className="text-brand-gold" aria-hidden="true" />
        </p>
      </div>
    </section>
  );
}
